import { render, staticRenderFns } from "./changeCardTui.vue?vue&type=template&id=fd0808ce&scoped=true&"
import script from "./changeCardTui.vue?vue&type=script&lang=js&"
export * from "./changeCardTui.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0808ce",
  null
  
)

export default component.exports